// Admin: tap a user's avatar → their photo grows into the middle of the
// screen for a closer look. Tap outside, the X or press Esc to close.
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { FiDownload, FiX } from "react-icons/fi";
import "./photoLightbox.css";

export default function PhotoLightbox({ src, name, onClose, onDownload }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  if (!src) return null;
  return createPortal(
    <div className="plb" onClick={onClose} role="dialog" aria-modal="true" aria-label={name ? `${name}'s photo` : "Photo"}>
      <button type="button" className="plb-close" onClick={onClose} aria-label="Close"><FiX /></button>
      <figure className="plb-figure" onClick={(e) => e.stopPropagation()}>
        <img src={src} alt={name || ""} className="plb-img" />
        {name && <figcaption className="plb-name">{name}</figcaption>}
        {onDownload && <button type="button" className="plb-download" onClick={onDownload}><FiDownload aria-hidden="true" /> Download</button>}
      </figure>
    </div>,
    document.body
  );
}
